module.exports = __webpack_public_path__ + "img/page-03.13c9393b.jpg";